import React, { useState } from "react";
import InputCreate from "../../features/InputCreate";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "../../store/slice/PrintSlice";
import instance from "../../api/api";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export default function RenouvellementContrat() {
  const MySwal = withReactContent(Swal);
  const [data, setData] = useState({
    date_entree: "",
    date_sortie: "",
    frequence_paiement: "mois",
  });
  const dispatch = useDispatch();
  const client_id = useSelector((state) => state.contratsReducer.client_id);
  const propriety_id = useSelector(
    (state) => state.contratsReducer.propriety_id
  );
  const saveOtherContrat = async () => {
    console.log({ client_id: client_id, propriety_id: propriety_id });
    const allDonnees = {
      date_entree: data.date_entree,
      date_sortie: data.date_sortie,
      frequence_paiement: data.frequence_paiement,
      client_id: client_id,
      propriety_id: propriety_id,
    };
    console.log("allDonnees", allDonnees);
    try {
      const response = await instance.post("/contracts", allDonnees);
      if (response["status"] === 200) {
        MySwal.fire({
          title: response.data.message,
          icon: "info",
          showConfirmButton: true,
        });
        dispatch(showModal());
      }
      console.log("saveOtherContrat", response.data);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <InputCreate
        label="Date d'entrée"
        typeInput="date"
        nameInput="Date d'entrée"
        active={true}
        getValue={(e) => {
          setData({ ...data, date_entree: e.target.value });
        }}
        dataValue={data.date_entree}
      />
      {/* <InputCreate
        label="Date de sortie"
        typeInput="date"
        nameInput="Date de sortie"
        active={true}
        getValue={(e) => {
          setData({ ...data, date_sortie: e.target.value });
        }}
        dataValue={data.date_sortie}
      /> */}
      <div>
        <label htmlFor="paiement_frequence">
          Choisir la fréquence de paiement (Mois)
        </label>
        <select
          name="paiement_frequence"
          id="paiement_frequence"
          onChange={(e) => {
            setData({ ...data, frequence_paiement: e.target.value });
          }}
          value={data.frequence_paiement}
          className="w-100 p-3 mb-2">
          <option value={""} disabled>
            Sélectionner une fréquence
          </option>
          <option value="mois">1</option>
          <option value="2mois">2</option>
          <option value="3mois">3</option>
          <option value="4mois">4</option>
          <option value="6mois">6</option>
          <option value="annee">12</option>
        </select>
      </div>
      <div className="d-flex justify-content-center align-items-center gap-3">
        <button
          className="btn bg-primary text-light"
          onClick={() => saveOtherContrat()}>
          Enregistrer
        </button>
        <button
          className="btn bg-danger text-light"
          onClick={() => dispatch(showModal())}>
          Annuler
        </button>
      </div>
    </>
  );
}
